<eds-rating
  [rating]="rating"
  size="small"
  [isHybrid]="isHybrid"
  [theme]="theme"
  [title]="'products.morningstar-review' | translate"
></eds-rating>

<p *ngIf="isHybrid && rating > 0" class="spacing--none">
  <button
    class="print-hidden"
    edsTooltip
    tooltipPositionDefault="bottom"
    [analyticsName]="'products.morningstar-review' | translate"
    tooltipType="large"
    tooltipBehavior="fixed"
    [tooltipContent]="'products.morningstar-tooltip' | translate"
    [tooltipAriaLabel]="'Morning star rating tooltip' | translate"
    [tooltipButton]="true"
  >
    <eds-icon type="info" size="small"></eds-icon>
  </button>
</p>

<p
  *ngIf="showCategory && rating > 0"
  class="ratings-cell-renderer__category spacing--none small"
>
  {{ ratingCategory }}
</p>

<button
  *ngIf="showViewDetails && rating > 0"
  edsButton="link-compact"
  (click)="onViewRatingsClick()"
>
  {{ "products.view-ratings-details" | translate }}
</button>

<p *ngIf="showNumberOfFunds && rating > 0" class="spacing--none small">
  {{ numberOfFunds }} {{ "products.funds-in-category" | translate }}
</p>

<p *ngIf="showStarLabels && rating > 0" class="spacing--none small">
  {{ starLabel }}
</p>
